<template>
    <div class="App">
      <router-view></router-view>
      <v-snackbar
        v-model="snackbar.showing"
        :timeout="snackbar.timeout"
        :color="snackbar.color"
      >
        {{ snackbar.text }}

        <template v-slot:action="{ attrs }">
          <v-btn
            :color="snackbar.btncolor"
            text
            v-bind="attrs"
            @click="snackbar.showing = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
      <!-- <Autologout></Autologout> -->
    </div>
</template>

<script>
import {mapState} from 'vuex'
// import Autologout from '@/components/Autologout/autologout'
export default {
  name: 'App',
  components: {
    // Autologout
  },
  data: () => ({
  }),
  computed: {
    ...mapState(['snackbar'])
  }
};
</script>
